// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// get global for google tag manager
function getDataLayer() {
    return (window as any).dataLayer;
}

/**
 * WES-1699
 * Override OOTB trackSearchResultEvent from "@insite/client-framework/Common/Utilities/tracking"
 * accepting email and push it with datalayer event
 * @param searchTerm
 * @param resultCount
 * @param correctedSearchTerm
 * @param email
 */
export function xTrackSearchResultEvent(
    searchTerm: string,
    resultCount: number,
    correctedSearchTerm?: string,
    userProfileId?: string,
) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();

    if (dataLayer && searchTerm) {
        dataLayer.push({
            event: "searchResults",
            searchQuery: searchTerm,
            correctedQuery: correctedSearchTerm,
            numSearchResults: resultCount,
            // Clear/Reset data for this layer
            searchTerm: null,
            /* eslint-disable */
            product_numSearchResults: null,
            categories_numSearchResults: null,
            content_numSearchResults: null,
            brands_numSearchResults: null,
            /* eslint-enable */
            userProfileId,
        });
    }
}
